import styled, { css } from 'styled-components';

export const ButtonTag = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 20px 5px;
  
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  text-transform: capitalize;
  
  background-color: transparent;
  border: none;
  outline: none;
  border-radius: 50px;
  
  cursor: pointer;
  
  svg {
    transition: fill 0.3s, stroke 0.3s;
  }
  
  &::-moz-focus-inner {
    border: 0;
  }
  
  ${({theme, btnType}) => btnType === 'primary' && css`
    color: ${theme.white};
    
    background-image: linear-gradient(159.02deg, #2DB9FE 0%, #4EDBFC 100%);
    box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);
    
    svg:not(.loader) {
      fill: ${theme.white};
      stroke: ${theme.white};
    }
    
    &:hover {
      color: ${theme.blue};
      
      background-image: none;
      box-shadow: inset 0 0 0 2px ${theme.blue};
      
      svg:not(.loader) {
        fill: ${theme.blue};
        stroke: ${theme.blue};
      }
    }
    a {
      font-color: ${({ theme }) => theme.white};
      &:hover {
        font-color: ${({ theme }) => theme.blue};
      }
    }
  `}
  
  ${({theme, btnType}) => btnType === 'secondary' && css`
    color: ${theme.blue};
    
    box-shadow: inset 0 0 0 2px ${theme.blue};
    
    svg:not(.loader) {
      fill: ${theme.blue};
      stroke: ${theme.blue};
    }
    
    &:hover {
      color: ${theme.white};
      
      svg:not(.loader) {
        fill: ${theme.white};
        stroke: ${theme.white};
      }
      
      background-image: linear-gradient(159.02deg, #2DB9FE 0%, #4EDBFC 100%);
      box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);
      border-color: transparent;
    }
  `}
  
  ${({ disabled, theme }) => disabled && css`
    color: ${theme.white};
    background: #d8d8d8;
    box-shadow: none;
    
    &:hover {
      color: ${theme.white};
      background: #d8d8d8;
      box-shadow: inset 0 0 0 2px #d8d8d8;
      
      cursor: not-allowed;
    }
  `}
`;
